import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const NumberInput = ({
  id = 'number-input', 
  min = 1, 
  max = 999, 
  value, 
  onChange 
}) => {
  const decrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const increment = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };
  
  const { t } = useTranslation();
  const isDecrementDisabled = value <= min;
  const isIncrementDisabled = value >= max;
  
  const commonTextStyle = {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '100%',
    letterSpacing: '0%',
    verticalAlign: 'middle'
  };
  
  const disabledButtonStyle = {
    cursor: 'not-allowed'
  };
  
  return (
    <div className="number-input-container" style={{ display: 'flex', alignItems: 'center', marginBottom: 32, marginTop: 24 }}>
      <button
        className="mainColor"
        type="button"
        onClick={decrement}
        disabled={isDecrementDisabled}
        style={{
          width: '36px',
          height: '36px',
          border: '1px solid #ccc',
          background: 'white',
          borderRadius: '4px',
          cursor: isDecrementDisabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...(isDecrementDisabled ? disabledButtonStyle : {}),
          ...commonTextStyle
        }}
        aria-label={t("Diminuer la quantité")}
      >
        -
      </button>
      <input
        type="text"
        id={id}
        className='mainColor'
        min={min}
        max={max}
        value={value}
        readOnly
        style={{
          width: '80px',
          height: '36px',
          border: '1px solid #ccc',
          textAlign: 'center',
          margin: '0 8px',
          borderRadius: '4px',
          ...commonTextStyle
        }}
        aria-label={t("Quantité")}
        aria-required="true"
      />

      <button
        type="button"
        className="mainColor"
        onClick={increment}
        disabled={isIncrementDisabled}
        style={{
          width: '36px',
          height: '36px',
          border: '1px solid #ccc',
          background: 'white',
          borderRadius: '4px',
          cursor: isIncrementDisabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...(isIncrementDisabled ? disabledButtonStyle : {}),
          ...commonTextStyle
        }}
        aria-label={t("Augmenter la quantité")}
      >
        +
      </button>


    </div>
  );
};

NumberInput.propTypes = {
  id: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};



export default NumberInput;